import { AmortisationType, EnergyLabel, LoanToValue, FixedRatePeriod } from '@ap/ap-interface-apix-rs-hypotheken-renteoverzicht';

export class Filters {
    constructor(
        public amortisationType: AmortisationType,
        public fixedRatePeriod: FixedRatePeriod,
        public loanToValue: LoanToValue,
        public energyLabel: EnergyLabel
    ) {}
}
